function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 94"
}, props), React.createElement("path", {
  d: "M2 76.09h4.526l3.017 8.971 2.12-8.97 2.128-8.971 3.01 8.97h5.929M56.447 38.847H62.122l3.324 9.899 2.345-9.9 2.345-9.898 3.324 9.899H80M39.537 19.573s7.839 1.424 18.869 0c0 0 1.245-.149 3.342-.46M30.375 37.28s-3.125-19.556 6.25-29.214V2",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M42.474 2v5.463s7.488 1.17 7.488 12.74M61.741 27.113c-1.988.312-3.408.503-3.408.503-5.198.538-9.157.709-9.157.709-.048 7.291 1.396 11.755 1.548 12.216a.104.104 0 00.048.056c5.119 2.53 9.035 7.554 10.667 13.697 0 0 1.668 7.072 1.022 16.071-.297 4.11-1.233 8.135-2.575 11.962-.786 2.239-1.59 3.989-2.333 5.342-1.777 3.231-5.022 4.854-8.244 4.181-10.443-2.175-20.868-14.023-20.868-14.023-2.648-3.125-4.551-6.136-5.893-8.985-4.249-9.006-2.563-20.28 3.832-27.338l2.683-2.962c2.98-3.287 7.174-4.62 11.157-3.493a.926.926 0 01.066.021c1.831-3.6 2.103-7.263 2.103-7.263s-.652-.085-1.51-.24c-1.735-.32-2.962-2.211-2.72-4.252.544-4.592 2.828-8.092 2.828-8.092",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M20.21 58.276C7.48 44.983 13.482 33.78 15.18 31.186c.472-.722.943-1.452 1.348-2.224 4.327-8.326 3.16-16.567 3.16-16.567M26.332 12.388s-1.3 10.594 3.795 12.18M43.066 53.302s.762 6.193 7.972 10.388M40.292 35.063s-8.939 16.531-1.034 27.104M47.056 60.615s-5.09 7.639 2.495 12.585",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M30.948 74.83c.496.552 9.966 10.997 18.983 12.882.272.056.544.085.816.085 1.53 0 2.962-.886 3.796-2.41.719-1.303 1.402-2.877 2.03-4.67A44.901 44.901 0 0058.9 69.913a35.125 35.125 0 01-2.018 4.067c-3.336 5.747-9.58 7.419-15.061 4.769-11.495-5.556-17.672-17.708-17.883-18.112.253 2.126.821 4.216 1.74 6.165 1.27 2.686 3.04 5.385 5.27 8.021v.007z",
  fill: "#C0D2D6"
})));